import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("保存模板")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", null, "返回", -1)

import LessonPlanEditor from '@/components/lesson-plan-editor/LessonPlanEditor.vue'
import { useRoute } from 'vue-router'
import { reactive, computed, onBeforeMount, getCurrentInstance } from 'vue'
import {
  createTeachPlanTemplate,
  editTeachPlanTemplate,
  getTeachPlanTemplateInfo
} from '@/services/teach-plan-template'
import { message } from 'ant-design-vue'


export default {
  setup(__props) {

const route = useRoute()

const currentInstance = getCurrentInstance()

const pageState = reactive({
  title: '新建模板',
  id: parseInt(route.params.templateId),
  current: {}
})

const queryParams = computed(() => {
  const params = {
    content: pageState.current.content,
    name: pageState.current.name
  }
  return params
})

// 初始化
if (pageState.id) {
  pageState.title = '编辑模板'
} else {
  pageState.title = '新建模板'
}

const handleSaveLessonPlan = (data) => {
  // 拿到了也存到了
  pageState.current.content = data
}

const handleSave = async () => {
  currentInstance.refs.sendText.handleSaveText()
  const notEmptyCheckArr = {
    content: '教案模板内容不能为空',
    name: '名称不能为空'
  }
  let finish = false
  for (const k in notEmptyCheckArr) {
    if (!queryParams.value[k] || queryParams.value[k] === '<p><br></p>') {
      message.error(notEmptyCheckArr[k])
      finish = true
      break
    }
  }
  if (finish) return

  try {
    if (pageState.id) {
      await editTeachPlanTemplate(pageState.id, queryParams.value)
    } else {
      await createTeachPlanTemplate(queryParams.value)
    }
    message.success('保存成功')
    history.go(-1)
  } catch (e) {
    console.error(e)
    message.error('保存失败')
    throw e
  }
}

const getTemplateInfo = async () => {
  if (!pageState.id) {
    return
  }
  pageState.current = await getTeachPlanTemplateInfo(pageState.id)
}

onBeforeMount(async () => {
  await getTemplateInfo()
})

const goBack = () => {
  history.go(-1)
}

return (_ctx, _cache) => {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, null, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_unref(pageState).title), 1)
      ]),
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"margin-right":"20px"},
          onClick: handleSave
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_a_popconfirm, {
          placement: "bottomRight",
          title: "模板尚未保存，确定要离开吗？",
          "ok-text": "确定",
          "cancel-text": "取消",
          onConfirm: goBack
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_row, {
            style: {"width":"100%"},
            gutter: 48
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                md: 8,
                sm: 24
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        disabled: _ctx.readOnly,
                        value: _unref(pageState).current.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = $event => (_unref(pageState).current.name = $event))
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(LessonPlanEditor, {
      onOnSave: handleSaveLessonPlan,
      textContent: _unref(pageState).current.content,
      ref: (_value, _refs) => {
        _refs['sendText'] = _value
      }
    }, null, 8, ["textContent"])
  ], 64))
}
}

}